import { v1ApiClient } from '@/services';
import type { PathParams, RequestBody, ResponseBody } from '@/shared/api/generated';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

type SignalsPath = '/v1/workspaces/{workspace_id}/signals';

type CreateSignalParams = Partial<PathParams<SignalsPath, 'post'>> &
  RequestBody<SignalsPath, 'post'>;
type CreateSignalResponse = ResponseBody<SignalsPath, 'post'>;
type CreateSignalFunction = (
  params: CreateSignalParams,
) => Promise<CreateSignalResponse>;

/**
 * Signal 생성
 */
export const createSignal: CreateSignalFunction = ({
  workspace_id,
  title,
  definition,
}) => {
  const wa = workspace_id ?? getCurrWorkspaceAlias();
  return v1ApiClient
    .post(`/workspaces/${wa}/signals`, { title, definition })
    .then((res) => res.data);
};
